import { useCallback, useEffect, useMemo, useState } from 'react';
import { FILE_UPLOAD_SESSION_STATE_TYPE, useFileUpload } from 'store';
import { shouldDisableSubmissionForFileUpload } from './shouldDisableSubmissionForFileUpload';

type UseSubmissionStateReturnType = {
  disabledSubmission: boolean;
  disabledControl: boolean;
  setDisabledControl: (disabled: boolean) => void;
};

export const useSubmissionState = (): UseSubmissionStateReturnType => {
  const [disabled, setDisabled] = useState(false);
  const fileUploadState = useFileUpload();
  const disabledSubmission = useMemo(() => {
    const shouldDisabledForFileUpload =
      shouldDisableSubmissionForFileUpload(fileUploadState);
    return disabled || shouldDisabledForFileUpload;
  }, [disabled, fileUploadState]);

  const setDisabledControl = useCallback((disabled: boolean) => {
    setDisabled(disabled);
  }, []);

  useEffect(() => {
    if (fileUploadState.session.type === FILE_UPLOAD_SESSION_STATE_TYPE.error) {
      setDisabled(true);
    }
  }, [fileUploadState.session.type]);

  return {
    disabledSubmission,
    disabledControl: disabled,
    setDisabledControl,
  };
};
